import { Flex } from 'antd';
import { FetchingErrorState } from '@shared/ui/fetching-error-state/fetching-error-state';
import { LoadingState } from '@shared/ui/loading-state/loading-state';
import { useGetIntegrations } from './hooks/use-get-integrations';
import { buildOrganizationRoute, Routes } from '@shared/constants/routes';
import { generatePath, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Integrations as IntegrationsModule } from './ui/integrations/integrations';
import { useEffect, useState } from 'react';
import { IntegrationDetails } from './ui/integration-details/integration-details';

export const Integrations = () => {
  const navigate = useNavigate();
  const { channelId, organizationId } = useParams<{
    channelId?: string;
    organizationId?: string;
  }>();
  const [searchParams] = useSearchParams();
  const [openIntegrationId, setOpenIntegrationId] = useState<number | null>(null);
  const normalizedOrganizationId =
    organizationId && Number.isFinite(Number(organizationId)) ? Number(organizationId) : null;
  const integrationsRoute = channelId
    ? normalizedOrganizationId
      ? buildOrganizationRoute(
          Routes.organizationScope.channelsIntegrations,
          normalizedOrganizationId,
          {
            channelId,
          },
        )
      : generatePath(Routes.channels.integrations, { channelId })
    : null;

  const {
    integrations,
    isLoading: isIntegrationLoading,
    isError: isIntegrationError,
    isFetching: isIntegrationFetching,
    refetch: refetchIntegration,
  } = useGetIntegrations(Number(channelId));

  const integrationIdParam = searchParams.get('integrationId');
  const isCreateMode = integrationIdParam === 'new';
  const integrationId =
    integrationIdParam && integrationIdParam !== 'new' ? Number(integrationIdParam) : null;

  useEffect(() => {
    if (integrationId && Number.isFinite(integrationId)) {
      setOpenIntegrationId(integrationId);
    }
  }, [integrationId]);

  const handleCreateIntegration = () => {
    if (!integrationsRoute) return;

    navigate(`${integrationsRoute}?integrationId=new`);
  };

  if (isCreateMode) {
    return <IntegrationDetails channelId={Number(channelId)} isCreateMode />;
  }

  if (integrationId && Number.isFinite(integrationId)) {
    return <IntegrationDetails integrationId={integrationId} channelId={Number(channelId)} />;
  }

  return (
    <Flex vertical style={{ height: '100%', width: '100%' }} gap={32}>
      {(() => {
        if (isIntegrationLoading || isIntegrationFetching) {
          return <LoadingState />;
        }

        if (isIntegrationError) {
          return <FetchingErrorState refetch={refetchIntegration} />;
        }

        return (
          <>
            <IntegrationsModule
              integrations={integrations}
              onCreateIntegration={handleCreateIntegration}
              isCreateLoading={false}
              openIntegrationId={openIntegrationId}
            />
          </>
        );
      })()}
    </Flex>
  );
};
